import { Key } from "react";

const ViverMelhorExtraPageLayout = (props: any) => {

  function renderObjectBody(data: any) {
    return { __html: data }
  }

  return (
    <>
      <div className='row justify-content-center'>
        <div className="col-lg-10 col-xl-10 section-page">

          {props.items?.map((item: { ID: Key | null | undefined; Corpo: any; }) => (
            <span key={item.ID}>
              {item.Corpo &&
                <span  dangerouslySetInnerHTML={renderObjectBody(item.Corpo)} />
              }
            </span>

          ))}

        </div>
      </div>
    </>
  )
}

export default ViverMelhorExtraPageLayout;